import { Card, Elevation } from "@blueprintjs/core";
import React from 'react';


class RentPreview extends React.Component {
  // Set default props
  static defaultProps = {
    values: {
      owner: {}, tenant: {}
    },
  }

  getDate = () => {
    let date = new Date();
    return date.toLocaleDateString();
  }

  render() {
    return (
      <div className="rent-agreement-preview is-size-6">
        <h2 className="is-size-4 has-text-grey has-text-weight-light" style={{ marginBottom: "1rem" }}>
          Preview
        </h2>
        <Card className="card has-text-centered" elevation={Elevation.ONE}>
          <p className="is-size-5">LEAVE AND LICENSE AGREEMENT</p>
          <p>
            This agreement is made and executed on {this.getDate()} at&nbsp;
            {this.props.selectedLocation && this.props.selectedLocation.name ? this.props.selectedLocation.name :
              <span className="text-nowrap has-text-grey">(<em>Select location</em>)</span>}
          </p>
          <p>
            Between,<br />
            1) Name: <strong>{this.props.values.owner.name || <span className="text-nowrap has-text-grey">(<em>Owner Name</em>)</span>}</strong>,&nbsp;
            Age: <strong>{this.props.values.owner.age || <span className="text-nowrap has-text-grey">(<em>Owner Age</em>)</span>}</strong>,&nbsp;
            Occupation: <strong>{this.props.values.owner.occupation || <span className="text-nowrap has-text-grey">(<em>Owner Occupation</em>)</span>}</strong>,&nbsp;
            PAN: <strong>{this.props.values.owner.panNumber || <span className="text-nowrap has-text-grey">(<em>Owner PAN No.</em>)</span>}</strong>
          </p>
          <p>HEREINAFTER called 'the Licensor' (which expression shall mean and include the Licensor above named and also his/her/their respective heirs, successors, assigns, executors and administrators)</p>
          <p>AND</p>
          <p>
            1) Name: <strong>{this.props.values.tenant.name || <span className="text-nowrap has-text-grey">(<em>Tenant Name</em>)</span>}</strong>,&nbsp;
            Age: <strong>{this.props.values.tenant.age || <span className="text-nowrap has-text-grey">(<em>Tenant Age</em>)</span>}</strong>,&nbsp;
            Occupation: <strong>{this.props.values.tenant.occupation || <span className="text-nowrap has-text-grey">(<em>Tenant Occupation</em>)</span>}</strong>,&nbsp;
            PAN: <strong>{this.props.values.tenant.panNumber || <span className="text-nowrap has-text-grey">(<em>Tenant PAN No.</em>)</span>}</strong>,&nbsp;
            Email-id: <strong>{this.props.values.tenant.email || <span className="text-nowrap has-text-grey">(<em>Tenant Email</em>)</span>}</strong>,&nbsp;
            Residing at: <strong>{this.props.values.tenant.permanentAddress || <span className="text-nowrap has-text-grey">(<em>Tenant Address</em>)</span>}</strong>
          </p>
        </Card>
      </div>
    );
  }
}

export default RentPreview;


// WEBPACK FOOTER //
// ./src/app/components/rent-agreement/agreement-preview.js